let _ = t => t,
  _t;
import { css } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import breakpoint from 'ui-addon-upgrades/_core/utils/responsiveBreakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureTableBadge = ({
  use = 'new',
  badgeType,
  badgeStyle
}) => {
  return /*#__PURE__*/_jsx(UIBadge, {
    use: use,
    style: badgeStyle,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: badgeType === 'recommended' ? `upgrades.featureTable.badges.recommended` : `upgrades.featureTable.badges.currentPlan`
    })
  });
};
export const paddingLeft = css(["padding-left:42px;", ""], breakpoint.tablet(_t || (_t = _`
    padding-left: 16px;
    `)));
export const rowHeaderStyles = css(["text-align:left;", ""], paddingLeft);